import apiOpsi from '@/api/vo-general/opsi';

const defaultState = () => ({
	provinces: [],
	cities: [],
	subdistricts: [],
	courierRajaongkir: [],
	costRajaongkir: [],
	packages: [],
	banks: [],
	uplineData: {},
	bankCompany: [],
	memberData: {},
	uplineList: [],
	cloneList: [],
	stockistQuota: [],
});

const state = defaultState();

const getters = {
};

const mutations = {
	setProvinces(state, data) {
		state.provinces = data
	},
	setCities(state, data) {
		state.cities = data
	},
	setSubdistricts(state, data) {
		state.subdistricts = data
	},
	setCourierRajaongkir(state, data) {
		state.courierRajaongkir = data.results
	},
	setCostRajaongkir(state, data) {
		state.costRajaongkir = data
	},
	setPackages(state, data) {
		state.packages = data
	},
	setBanks(state, data) {
		state.banks = data
	},
	setUplineData(state, data) {
		state.uplineData = data
	},
	setBankCompany(state, data) {
		state.bankCompany = data
	},
	setMemberData(state, data) {
		state.memberData = data.results
	},
	setUplineList(state, data) {
		state.uplineList = data
	},
	emptyMemberData(state) {
		state.memberData = {}
	},
	setCloneList(state, data) {
		state.cloneList = data.results
	},
	setStockistQuota(state, data) {
		state.stockistQuota = data.results
	},
	clearOptions(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getProvince({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getProvince(params).then((results) => {
				const data = results.data.data
				commit('setProvinces', data.results)
				resolve(data)
			}).catch((err) => {
				dispatch('errorHandler', err, { root : true });
				// commit('setSnackbar', {
				// 	show: true,
				// 	color: 'red darken-2',
				// 	text: 'Data Provinsi tidak dapat ditampilkan, silakan muat ulang halaman'
				// }, { root: true });
				reject()
			});
		});
	},
	getCity({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getCity(params).then((results) => {
				const data = results.data.data
				commit('setCities', data.results)
				resolve(data)
			}).catch((err) => {
				dispatch('errorHandler', err, { root : true });
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Data Kota/Kabupaten tidak dapat ditampilkan, silakan muat ulang halaman'
				}, { root: true });
				reject()
			});
		});
	},
	getSubdistrict({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getSubdistrict(params).then((results) => {
				const data = results.data.data
				commit('setSubdistricts', data.results)
				resolve(data)
			}).catch((err) => {
				dispatch('errorHandler', err, { root : true });
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Data Kecamatan tidak dapat ditampilkan, silakan muat ulang halaman'
				}, { root: true });
				reject()
			});
		});
	},
	getCourierRajaongkir({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getCourierRajaongkir(params).then((results) => {
				const data = results.data.data
				commit('setCourierRajaongkir', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getCostRajaongkir({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getCostRajaongkir(params).then((results) => {
				const data = results.data
				commit('setCostRajaongkir', data.data.rajaongkir.results);
				dispatch('success', data, { root : true });
				resolve(data)
			}).catch((err) => {
				reject(err.response);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getPackageList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getPackageList(params).then((results) => {
				const data = results.data.data
				commit('setPackages', data.results)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root: true });
			});
		});
	},
	getBank({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getBank(params).then((results) => {
				const data = results.data.data
				commit('setBanks', data.results)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getUplineData({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getUplineData(params).then((results) => {
				const data = results.data.data
				commit('setUplineData', data.results)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root: true });
			});
		});
	},
	getBankCompany({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getBankCompany(params).then((results) => {
				const data = results.data.data
				commit('setBankCompany', data.results)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getMemberByCode({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getMemberByCode(params).then((results) => {
				const data = results.data.data
				commit('setMemberData', data.results)
				resolve(data.results)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getUplineOptions({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getUplineOptions(params).then((results) => {
				const data = results.data.data
				commit('setUplineList', data.results)
				resolve(data.results)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getCloneList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getCloneList(params).then((results) => {
				const data = results.data.data
				commit('setCloneList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getStockistQuota({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiOpsi.getStockistQuota(params).then((results) => {
				const data = results.data.data
				commit('setStockistQuota', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};